/**
 * Guarded access to `window.localStorage`. Browsers can deny storage even when
 * the API exists — privacy modes and embedded contexts throw a SecurityError on
 * property access — so callers must treat storage as optional.
 */
export function getLocalStorage(): Storage | null {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}
